<div class="tile__status tile__status--default" data-testid="tile">
    <div class="tile__svg--other-wrapper bg-img">
        <img class="tile__svg--other"
             ngSrc="{{ icon.setIcon(tile.params.iconId)}}"
             width="50" height="50" alt="" />
    </div>
    <div class="tile__title-wrapper font-14">
        <p class="tile__title">
           {{ subtitle(tile.params.txtId) + ': ' + tile.params.version }}
        </p>
    </div>
    <div class="tile__setting cursor-pointer"
         [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
         *ngIf="tile.elementMenu && tile.menuId !== 0"
         (click)="goControl()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
             width="30" height="30" alt="" />
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange === 't'">
           {{ subtitle(3162) }}
        </p>
    </div>
</div>
